import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import useCheckCallConnected from "../../hooks/useCheckCallConnected";

import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { CALL_BODY_SCREEN, ENABLED, EXTRACT_TEXT_VIEW, MARKUP_VIEW } from "../../constants/Constants";

import uploadFilesService from "../../services/uploadFilesService";
import livePointerService from "../LivePointer/livePointerService";
import MarkupService from "../../services/MarkupService/markupService";
import { LogFirebase } from "../../services/firestore";
import { setContinueMarkup } from "../../reducers/markup-reducer";
import GalleryViewTooltip from "../UI/Tooltip/GalleryViewTooltip";
import useShowGalleryViewTooltip from "../../hooks/useShowGalleryViewTooltip";

const MarkupButton = () => {
    const isCallNotConnected = useCheckCallConnected();
    const showGalleryViewTooltip = useShowGalleryViewTooltip();
    const localisedValues = useLanguageChange();
    const dispatch = useDispatch();
    const { allowMarkup, currentCallBodyScreen } = useSelector((state) => state.commonReducer);
    const { extractTextInprogress } = useSelector((state) => state.extractText);
    const { livePointerInProgress } = useSelector((state) => state.livePointer);
    const { markupInprogress } = useSelector((state) => state.markup);
    const { streamingPartiIdentity } = useSelector((state) => state.twilioEvents);

    const checkButtonDisabled = () => {
        /* for multiple click handle - add condition for mark up inprogress*/
        return (
            uploadFilesService.isUploadFilesView() ||
            !allowMarkup ||
            currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN ||
            livePointerInProgress ||
            extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW ||
            extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW
        );
    };

    const startMarkup = () => {
        if (markupInprogress === MARKUP_VIEW.OFF_VIEW) {
            // call this function (checkLiveLocation()) to check if live location is on then close it
            LogFirebase("Markup", "markup_clicked", "streaming user=" + streamingPartiIdentity);
            dispatch(setContinueMarkup(true));
            livePointerService.livePointerOnMarkupOCR();
            MarkupService.startHDCapture();
        }
    };

    return (
        <>
            {GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag?.SHOWMELIVEANNOTATION === ENABLED && (
                <div className='action-button' data-testid='markup-button-component'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className='call-action-btn'
                            disabled={isCallNotConnected || checkButtonDisabled()}
                            onClick={() => startMarkup()}
                            data-testid='markup-button'
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-markup'></span>
                            </span>
                            <span className='for-text'>{localisedValues?.markup}</span>
                        </button>
                        {showGalleryViewTooltip && !checkButtonDisabled() && <GalleryViewTooltip localisedValues={localisedValues} />}
                    </div>
                </div>
            )}
        </>
    );
};

export default MarkupButton;
